import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import da from '../assets/icons/flags/da.svg';
import no from '../assets/icons/flags/no.svg';
import sv from '../assets/icons/flags/sv.svg';
import uk from '../assets/icons/flags/uk.svg';
import { IFlagList } from '../constans/flags';
import { manageLangUpdateState, updateUserLang } from '../redux/slices/auth.slice';
import { RootState } from '../redux/store';

export const useLangManagement = () => {
  const {
    auth: {
      userData: { langIsUpdating, lang },
    },
  } = useSelector((store: RootState) => store);
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const availableLanguages = i18n.languages as string[];

  const { language } = i18n;
  // const localLang = localStorage.getItem('lang') || language;

  const flagsList: IFlagList = useMemo(() => {
    return {
      en: {
        id: 'fl1',
        flagName: t('surveys.stripMenu.english'),
        name: t('surveys.stripMenu.english'),
        shortName: 'en',
        shortDisplayName: 'eng',
        icon: uk,
      },
      no: {
        id: 'fl2',
        flagName: t('surveys.stripMenu.norsk'),
        name: t('surveys.stripMenu.norsk'),
        shortName: 'nb',
        shortDisplayName: 'nor',
        icon: no,
      },
      sv: {
        id: 'fl3',
        flagName: t('surveys.stripMenu.swedish'),
        name: t('surveys.stripMenu.swedish'),
        shortName: 'sv',
        shortDisplayName: 'sv',
        icon: sv,
      },
      nb: {
        id: 'fl4',
        flagName: t('surveys.stripMenu.norsk'),
        name: t('surveys.stripMenu.norsk'),
        shortName: 'nb',
        shortDisplayName: 'nb',
        icon: no,
      },
      da: {
        id: 'fl5',
        flagName: t('surveys.stripMenu.danish'),
        name: t('surveys.stripMenu.danish'),
        shortName: 'da',
        shortDisplayName: 'da',
        icon: da,
      },
    };
  }, [t]);

  const flagListAlternativeNames: IFlagList = useMemo(() => {
    return {
      en: {
        id: 'fl1',
        flagName: 'English',
        name: t('surveys.stripMenu.english'),
        shortName: 'en',
        shortDisplayName: 'eng',
        icon: uk,
      },
      no: {
        id: 'fl2',
        flagName: 'Norwegian',
        name: t('surveys.stripMenu.norAlt'),
        shortName: 'nb',
        shortDisplayName: 'nor',
        icon: no,
      },
      sv: {
        id: 'fl3',
        flagName: 'Swedish',
        name: t('surveys.stripMenu.swedish'),
        shortName: 'sv',
        shortDisplayName: 'sv',
        icon: sv,
      },
      nb: {
        id: 'fl4',
        flagName: 'Norwegian',
        name: t('surveys.stripMenu.norAlt'),
        shortName: 'nb',
        shortDisplayName: 'nb',
        icon: no,
      },
      da: {
        id: 'fl5',
        flagName: 'Danish',
        name: t('surveys.stripMenu.danish'),
        shortName: 'da',
        shortDisplayName: 'da',
        icon: da,
      },
    };
  }, [t]);

  const langArrWithIcons = useMemo(() => {
    return availableLanguages.map((lang: string) => flagsList[lang as keyof IFlagList]);
  }, [flagsList, availableLanguages]);

  const currentLanguageObject = useMemo(
    () => flagsList[language as keyof IFlagList],
    [flagsList, language]
  );

  const changeLanguage = async (selectedLang: string) => {
    await dispatch(manageLangUpdateState({ langIsUpdating: true }));
    await dispatch(updateUserLang({ lang: selectedLang }));
    localStorage.setItem('lang', selectedLang);
    const { changeLanguage } = i18n;
    await changeLanguage(selectedLang);
    dispatch(manageLangUpdateState({ langIsUpdating: false }));
  };

  return {
    currentLang: language,
    langArrWithIcons,
    currentLanguageObject,
    changeLanguage,
    langIsUpdating,
    lang,
    flagsList,
    flagListAlternativeNames,
  };
};
